module.exports = __webpack_public_path__ + "static/media/space-2.d3a2aa42.png";